/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import {
  Box,
  Grid,
  Checkbox,
  Chip,
  TextField,
  Autocomplete,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import AutoCompleteDropdown from "../../../components/common/new/AutoCompleteDropdown/AutoCompleteDropdown";
import InputField from "../../../components/common/new/InputField/InputField";
import useQueryParams from "../../../hooks/useQueryParams";
import {
  SET_CITIES,
  SET_DIVISIONS,
  SET_ROLES,
  SET_SPECIAL_GROUP,
  SET_STATES,
  SET_SUB_DIVISIONS,
} from "../../../redux/actionTypes/meta";
import IntroductionFormApi from "../../../services/api/introductionForm";
import { getOptions } from "../../../utils";
import { isEmptyObj } from "../../../utils/helper";
import Styles from "./MemberSearch.styles";
import User from "../../../services/api/user";
import SpecialGroup from "../../../services/api/SpecialGroup";

function PersonalDetailsSearch({ isRoleManagement, isMemberReport }) {
  const [stateVal, setStateVal] = useState("");
  const [divisionVal, setDivisionVal] = useState("");
  const [subDivisionVal, setSubDivisionVal] = useState("");
  const [cityVal, setCityVal] = useState("");
  const [divisions, setDivisions] = useState([]);
  const [subDivisions, setSubDivisions] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [specialGroups, setSpecialGroups] = useState([]);
  const [specialGroupVal, setSpecialGroupVal] = useState("");
  const [roles, setRoles] = useState([]);
  const [roleValue, setRoleValue] = useState([]);
  const [fullName, setFullName] = useState("");
  const [address, setAddress] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [pincode, setPincode] = useState("");

  const [mainlinePositions, setMainlinePositions] = useState([]);
  const [selectedMainlinePositions, setSelectedMainlinePositions] = useState(
    []
  );

  const dispatch = useDispatch();
  const { getQueryObject, getQueryParams, urlSearchParams } = useQueryParams();

  const MAINLINE_POSITION = "MAINLINE_POSITION";

  const setMetaDataInRedux = (type, payload) => {
    dispatch({ type, payload });
  };

  const getMainlinePositions = async () => {
    try {
      const response = await IntroductionFormApi.getAllPositions(
        MAINLINE_POSITION
      );
      const formattedMainlinePositions =
        response?.data?.map((d) => ({
          label: d.name,
          value: d.positionId,
        })) ?? [];
      setMainlinePositions(formattedMainlinePositions);
    } catch (error) {
      console.error("Failed to fetch mainline positions", error);
    }
  };

  const getDivisions = async () => {
    const response = await IntroductionFormApi.getDivisions();
    setDivisions(response.data);
    setMetaDataInRedux(SET_DIVISIONS, response.data);
  };

  const getStates = async () => {
    const response = await IntroductionFormApi.getStates();
    setStates(response.data);
    setMetaDataInRedux(SET_STATES, response.data);
  };

  const getRoles = async () => {
    const [rolesRes] = await Promise.all([User.getRole()]);
    const rolePos =
      rolesRes?.data?.map((d) => ({
        label: d.name, // label or entityTitle dono theek hai
        value: d.roleId,
      })) ?? [];
    setRoles(rolePos); // local state me save karo
    dispatch({ type: SET_ROLES, payload: rolePos });
  };

  const getSpecialGroup = async (divisionId) => {
    const response = await SpecialGroup.getDivisionSpecialGroup({ divisionId });
    setSpecialGroups(response.data);
    setMetaDataInRedux(SET_SPECIAL_GROUP, response.data);
  };

  useEffect(() => {
    getDivisions();
    getStates();
    getMainlinePositions();
    if (isRoleManagement) getRoles();
  }, []);

  useEffect(() => {
    const queryObject = getQueryObject();
    if (!isEmptyObj(queryObject)) {
      const query = getQueryParams(queryObject)[0];
      setStateVal(query?.state || "");
      setCityVal(query?.city || "");
      setDivisionVal(query?.divisionId || "");
      setSubDivisionVal(query?.subdivisionId || "");
      setSpecialGroupVal(query?.specialGroupId || "");
      if (query?.mainlinePositionIds && mainlinePositions.length > 0) {
        const positionIdsArray = query.mainlinePositionIds.split(",");
        setSelectedMainlinePositions(
          mainlinePositions.filter((pos) =>
            positionIdsArray.includes(String(pos.value))
          )
        );
      }
    } else {
      setStateVal("");
      setCityVal("");
      setDivisionVal("");
      setSubDivisionVal("");
      setSpecialGroupVal("");
      setSelectedMainlinePositions([]);
    }
  }, [urlSearchParams.toString(), mainlinePositions]);

  useEffect(() => {
    if (states.length && stateVal) {
      const newCities =
        states.find((state) => state.stateId === Number(stateVal))?.cities ??
        [];
      setCities(newCities);
      setMetaDataInRedux(SET_CITIES, newCities);
    }
  }, [states, stateVal]);

  useEffect(() => {
    if (divisions.length && divisionVal) {
      const newSubDivisions =
        divisions.find(
          (division) => division.divisionId === Number(divisionVal)
        )?.subDivisions ?? [];
      getSpecialGroup(divisionVal);
      setSubDivisions(newSubDivisions);
      setMetaDataInRedux(SET_SUB_DIVISIONS, newSubDivisions);
    }
  }, [divisions, divisionVal]);

  return (
    <Box
      sx={{
        px: 0,
        pt: 0,
        pr: { xs: "20px", sm: 0 },
        "& .MuiInputLabel-root": {
          fontSize: "12px",
          fontWeight: 600,
          lineHeight: "13px",
        },
        "& .MuiOutlinedInput-input": {
          height: "12px",
        },
      }}
    >
      <Box sx={{ pl: { xs: 0, sm: 2, md: 0 }, width: "100%" }}>
        <Grid
          container
          spacing={2}
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "1fr 1fr",
              md: "repeat(4, 1fr)",
            },
            rowGap: 0,
            columnGap: 1,
          }}
        >
          {/* Group 1 */}
          <Grid
            item
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 3,
              paddingRight: "8px",
              paddingBottom: "8px",
              boxShadow: "1px 0 2px 0 #e7e2e2",
            }}
          >
            <InputField
              label="Member ID"
              name="memberId"
              style={Styles.textfieldStyle}
              onChange={(e) => {
                const onlyNums = e.target.value.replace(/\D/g, ""); // non-digits remove
                e.target.value = onlyNums; // sirf numbers hi input me dikhega
              }}
            />

            {/* <InputField
              label="Member Name"
              name="fullName"
              style={Styles.textfieldStyle}
            /> */}
            <InputField
              label="Member Name"
              name="fullName"
              value={fullName}
              style={Styles.textfieldStyle}
              onChange={(e) => {
                const { value } = e.target;
                const regex = /^[A-Za-z ]*$/;
                if (regex.test(value)) {
                  setFullName(value);
                }
              }}
            />

            {!isRoleManagement && (
              <>
                <Autocomplete
                  multiple
                  disableCloseOnSelect
                  options={mainlinePositions}
                  getOptionLabel={(option) => option.label}
                  value={selectedMainlinePositions}
                  onChange={(event, newValue) =>
                    setSelectedMainlinePositions(newValue)
                  }
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        style={{ marginRight: 5, padding: 0 }}
                        checked={selected}
                        size="small"
                      />
                      {option.label}
                    </li>
                  )}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip
                        key={option.value}
                        label={option.label}
                        size="small"
                        sx={{
                          height: "24px",
                          fontSize: "12px",
                          margin: "2px",
                        }}
                        {...getTagProps({ index })}
                      />
                    ))
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Mainline Positions"
                      placeholder="Select..."
                      size="small"
                      sx={{
                        "& .MuiInputBase-root": {
                          minHeight: "32px",
                          height: "auto",
                          fontSize: "12px",
                          borderRadius: "4px",
                          alignItems: "center",
                        },
                        "& .MuiInputLabel-root": {
                          fontSize: "12px",
                          top: "0px",
                        },
                        "& .MuiInputLabel-shrink": {
                          top: "0px",
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderRadius: "8px",
                        },
                      }}
                    />
                  )}
                  sx={{
                    width: {
                      xs: "100%",
                      sm: "100%",
                    },
                    "& .MuiAutocomplete-inputRoot": {
                      paddingTop:
                        selectedMainlinePositions.length === 0 ? "0px" : "auto",
                    },
                  }}
                />
                <input
                  type="hidden"
                  name="mainlinePositionIds"
                  value={selectedMainlinePositions
                    .map((p) => p.value)
                    .join(",")}
                />
              </>
            )}

            {isRoleManagement && (
              <>
                <Autocomplete
                  multiple
                  disableCloseOnSelect
                  options={roles}
                  getOptionLabel={(option) => option.label}
                  value={roleValue}
                  onChange={(event, newValue) => setRoleValue(newValue)}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        style={{ marginRight: 5, padding: 0 }}
                        checked={selected}
                        size="small"
                      />
                      {option.label}
                    </li>
                  )}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip
                        key={option.value}
                        label={option.label}
                        size="small"
                        sx={{
                          height: "24px",
                          fontSize: "12px",
                          margin: "2px",
                        }}
                        {...getTagProps({ index })}
                      />
                    ))
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Role"
                      placeholder="Select..."
                      size="small"
                      sx={{
                        "& .MuiInputBase-root": {
                          minHeight: "33px",
                          height: "auto",
                          fontSize: "12px",
                          borderRadius: "4px",
                          alignItems: "center",
                        },
                        "& .MuiInputLabel-root": {
                          fontSize: "12px",
                          top: "0px",
                        },
                        "& .MuiInputLabel-shrink": {
                          top: "0px",
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderRadius: "8px",
                        },
                      }}
                    />
                  )}
                  sx={{
                    width: {
                      xs: "100%",
                      sm: "100%",
                    },
                    "& .MuiAutocomplete-inputRoot": {
                      paddingTop: roleValue.length === 0 ? "0px" : "auto",
                    },
                  }}
                />
                <input
                  type="hidden"
                  name="roleIds"
                  value={roleValue.map((r) => r.value).join(",")}
                />
              </>
            )}
          </Grid>

          {/* Group 2 */}
          <Grid
            item
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 3,
              paddingRight: "8px",
              paddingBottom: "8px",
              boxShadow: "1px 0 2px 0 #e7e2e2",
            }}
          >
            {/* <InputField
              label="Phone Number"
              name="mobileNumber"
              type="text"
              inputProps={{ maxLength: 10 }}
              style={Styles.textfieldStyle}
            /> */}
            <InputField
              label="Phone Number"
              name="mobileNumber"
              type="text"
              value={mobileNumber} // controlled input
              inputProps={{ maxLength: 10 }}
              style={Styles.textfieldStyle}
              onChange={(e) => {
                const { value } = e.target;

                // Regex: sirf digits 0-9 allow kare
                const regex = /^[0-9]*$/;

                // Agar value valid hai to update karo
                if (regex.test(value)) {
                  setMobileNumber(value);
                }
              }}
              onBlur={() => {
                // Optional: ensure exactly 10 digits
                if (mobileNumber && mobileNumber.length !== 10) {
                  // alert("Please enter a valid 10-digit phone number");
                  setMobileNumber("");
                }
              }}
            />
            <InputField
              label="Email Id"
              name="emailId"
              style={Styles.textfieldStyle}
              type="email"
            />
          </Grid>

          {/* Group 3 */}
          <Grid
            item
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 3,
              paddingRight: "8px",
              paddingBottom: "8px",
              boxShadow: "1px 0 2px 0 #e7e2e2",
            }}
          >
            {/* <InputField
              label="Address"
              name="address"
              style={Styles.textfieldStyle}
            /> */}
            <InputField
              label="Address"
              name="address"
              value={address}
              style={Styles.textfieldStyle}
              onChange={(e) => {
                const { value } = e.target;

                // Allowed: letters, digits, space, comma, dot, hyphen, slash
                const regex = /^[A-Za-z0-9 ,.\-/]*$/;

                if (regex.test(value)) {
                  setAddress(value);
                }
              }}
            />

            {/* <InputField
              label="Pincode"
              type="text"
              name="pincode"
              inputProps={{ maxLength: 6 }}
              style={Styles.textfieldStyle}
            /> */}
            <InputField
              label="Pincode"
              type="text"
              name="pincode" // ⬅️ ye zaroori hai
              value={pincode}
              inputProps={{ maxLength: 6 }}
              onChange={(e) => {
                const { value } = e.target;
                if (/^[0-9]*$/.test(value)) setPincode(value);
              }}
            />

            <AutoCompleteDropdown
              getOptionLabel={(option) => option.stateName}
              label="State"
              name="state"
              options={getOptions(states, "stateId")}
              value={stateVal}
              style={Styles.dropdownfieldStyle}
              inputProps={{ required: false }}
              onChange={(selectedValue) => {
                if (!selectedValue) {
                  setStateVal("");
                  setCities([]);
                } else {
                  setStateVal(selectedValue.value);
                  setCities(selectedValue.cities);
                  setMetaDataInRedux(SET_CITIES, selectedValue.cities);
                }
              }}
              useHiddenInput
            />
            <AutoCompleteDropdown
              getOptionLabel={(option) => option.cityName}
              label="City"
              name="city"
              options={getOptions(cities, "cityId")}
              value={cityVal}
              style={Styles.dropdownfieldStyle}
              disabled={!stateVal}
              inputProps={{ required: false }}
              onChange={(selectedValue) => {
                if (!selectedValue) {
                  setCityVal("");
                } else {
                  setCityVal(selectedValue.value);
                }
              }}
              useHiddenInput
            />
          </Grid>

          {/* Group 4 */}
          <Grid
            item
            sx={{
              display: "flex",
              flexDirection: "column",
              paddingRight: "8px",
              paddingBottom: "8px",
              gap: 3,
              boxShadow: "1px 0 2px 0 #e7e2e2",
            }}
          >
            <AutoCompleteDropdown
              getOptionLabel={(option) => option.shortName}
              label="Division"
              name="divisionId"
              options={getOptions(divisions, "divisionId")}
              value={divisionVal}
              style={Styles.dropdownfieldStyle}
              inputProps={{ required: false }}
              onChange={(selectedValue) => {
                if (!selectedValue) {
                  setDivisionVal("");
                  setSubDivisions([]);
                } else {
                  setDivisionVal(selectedValue.value);
                  setSubDivisions(selectedValue.subDivisions);
                  setMetaDataInRedux(
                    SET_SUB_DIVISIONS,
                    selectedValue.subDivisions
                  );
                }
              }}
              useHiddenInput
            />
            <AutoCompleteDropdown
              getOptionLabel={(option) => option.name}
              label="Sub Division"
              name="subdivisionId"
              options={getOptions(subDivisions, "divisionId")}
              value={subDivisionVal}
              style={Styles.dropdownfieldStyle}
              disabled={!divisionVal}
              onChange={(selectedValue) => {
                if (!selectedValue) {
                  setSubDivisionVal("");
                } else {
                  setSubDivisionVal(selectedValue.value);
                }
              }}
              useHiddenInput
            />
            {!isMemberReport && !isRoleManagement && (
              <AutoCompleteDropdown
                getOptionLabel={(option) => option.name}
                options={getOptions(specialGroups, "specialGroupId")}
                label="Special Group"
                name="specialGroupId"
                disabled={!divisionVal}
                value={specialGroupVal}
                onChange={(selectedValue) => {
                  if (!selectedValue) {
                    setSpecialGroupVal("");
                  } else {
                    setSpecialGroupVal(selectedValue.value);
                  }
                }}
                inputProps={{ required: false }}
                useHiddenInput
                style={Styles.dropdownfieldStyle}
              />
            )}
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default PersonalDetailsSearch;
